import React from 'react';
import { Modal, Button, Typography, Space, Divider } from 'antd';
import {
  RocketOutlined,
  TeamOutlined,
  CheckCircleFilled,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const RegisterPromptModal = ({ open, onClose, triggerAction = '' }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
    >
      <div style={{ padding: '16px 0', textAlign: 'center' }}>
        <Title level={4} style={{ marginBottom: 8 }}>
          無料で実際に試してみませんか？
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 16 }}>
          {triggerAction
            ? `「${triggerAction}」をご利用いただくには、アカウント登録が必要です。`
            : '全機能をご利用いただくには、アカウント登録が必要です。'}
        </Paragraph>

        <Space direction="vertical" size={6} style={{ marginBottom: 20, width: '100%', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
            <CheckCircleFilled style={{ color: '#0072ff' }} />
            <span>無料登録後、チュートリアルに沿って1記事無料で作成</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
            <CheckCircleFilled style={{ color: '#0072ff' }} />
            <span>クレジットカード不要で登録可能</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
            <CheckCircleFilled style={{ color: '#0072ff' }} />
            <span>14日間のフルトライアルも用意</span>
          </div>
        </Space>

        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <Button
            type="primary"
            size="large"
            icon={<RocketOutlined />}
            block
            onClick={() => navigate('/register')}
          >
            登録して試してみる
          </Button>

          <Divider plain style={{ margin: '8px 0' }}>
            法人のお客様
          </Divider>

          <Button
            size="large"
            icon={<TeamOutlined />}
            block
            onClick={() => navigate('/reserve-mtg')}
          >
            ミーティングを予約する
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default RegisterPromptModal;
